import Entity from '../views/PrevisaoAgendamentos/PrevisaoAgendamentos'

let routes = {
    path: '/previsao-agendamentos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/previsao-agendamentos',
            name: 'previsao-agendamentos',
            component: Entity,
            meta: {
                pageTitle: 'Previsão de Agendamentos',
                breadcrumb: [
                    {
                        text: 'Relatórios',
                        active: false,
                    },
                    {
                        text: 'Previsão de Agendamentos',
                        active: true,
                        to: '/previsao-agendamentos',
                    },
                ],
            },
        },
    ]
};

export default routes
